import { render, staticRenderFns } from "./PlantListEditor.vue?vue&type=template&id=35d40542&scoped=true&"
import script from "./PlantListEditor.vue?vue&type=script&lang=js&"
export * from "./PlantListEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d40542",
  null
  
)

export default component.exports